export default __webpack_public_path__ + "static/media/prescription_template.0e8fee2d.pdf";